import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export const API = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';
export const EDU = `${API}/education`;

export const STATUS_KEYS = ['present', 'late', 'absent', 'excused'];
// Цвет каждой отметки: зелёный — был, жёлтый — опоздал, красный — не был, серый — уважительная причина
export const STATUS_STYLE = {
  present: { on: 'bg-emerald-600 text-white border-emerald-600', off: 'text-emerald-700 border-emerald-200 hover:bg-emerald-50', dot: 'bg-emerald-500' },
  late:    { on: 'bg-amber-500 text-white border-amber-500',     off: 'text-amber-700 border-amber-200 hover:bg-amber-50',     dot: 'bg-amber-500' },
  absent:  { on: 'bg-red-600 text-white border-red-600',         off: 'text-red-700 border-red-200 hover:bg-red-50',           dot: 'bg-red-500' },
  excused: { on: 'bg-slate-600 text-white border-slate-600',     off: 'text-slate-600 border-slate-200 hover:bg-slate-50',     dot: 'bg-slate-400' },
};
export const GROUP_COLORS = ['#3b82f6', '#8b5cf6', '#ec4899', '#ef4444', '#f59e0b', '#10b981', '#06b6d4', '#64748b'];

// Скачать файл с сервера (xlsx и т.п.) вместе с авторизацией; имя берётся из Content-Disposition
export async function downloadFile(url, params, fallbackName) {
  const res = await axios.get(url, { params, responseType: 'blob' });
  let name = fallbackName || 'file';
  const cd = res.headers?.['content-disposition'] || '';
  const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
  const plain = cd.match(/filename="?([^";]+)"?/i);
  try { if (star) name = decodeURIComponent(star[1]); else if (plain) name = plain[1]; } catch { /* оставляем имя по умолчанию */ }
  const a = document.createElement('a');
  a.href = URL.createObjectURL(res.data);
  a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export const errMsg = (e, fallback) => e?.response?.data?.message || fallback || e?.message || 'Error';
export const apiErr = (e, fallback) => toast.error(errMsg(e, fallback));

// YYYY-MM-DD → Date в полдень (без сдвига часового пояса)
export const dateOf = (s) => new Date(`${s}T12:00:00`);
export const addDaysStr = (s, n) => { const d = dateOf(s); d.setDate(d.getDate() + n); const p = (x) => String(x).padStart(2, '0'); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };

// «Пн, Ср 15:00–16:30»: расписание группы одной строкой
export function scheduleText(schedule, t) {
  if (!schedule?.length) return '—';
  const byTime = {};
  for (const s of schedule) { const k = `${s.start}${s.end ? '–' + s.end : ''}`; (byTime[k] = byTime[k] || []).push(s.day); }
  return Object.entries(byTime).map(([time, days]) => `${days.sort().map((d) => t(`edu.d${d}`)).join(', ')} ${time}`).join(' · ');
}

// Загрузка данных с обновлением: { data, loading, reload }
export function useEduData(path, params, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const reload = useCallback(async () => {
    setLoading(true);
    try { const r = await axios.get(`${EDU}${path}`, { params }); setData(r.data); }
    catch (e) { apiErr(e); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, key, ...deps]);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, reload, setData };
}
